<template>
  <div
    :id
    class="container paragraph-status-message message my-spacing-md"
    :class="{
      'is-primary': statusType === 'info',
      'is-danger': statusType === 'error',
      'is-warning': statusType === 'warning',
      'is-success': statusType === 'success',
    }"
    :data-status-type="statusType"
  >
    <div v-blokkli-editable:field_title class="message-header">
      <p>{{ title }}</p>
    </div>
    <div v-blokkli-editable:field_body class="message-body" v-html="body" />
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphAppStatusMessageFragment } from '#graphql-operations'

defineProps<ParagraphAppStatusMessageFragment>()

const { options, index, siblings } = defineBlokkli({
  bundle: 'app_status_message',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    statusType: {
      type: 'radios',
      label: 'Type',
      default: 'info',
      displayAs: 'radios',
      options: {
        info: 'Info',
        error: 'Error',
        warning: 'Warning',
        success: 'Success',
      },
    },
  },
})

const id = useParagraphAnchorId(index, siblings)
const statusType = computed(() => options.value.statusType)
</script>
